import React from 'react';

import {Fieldset} from 'primereact/fieldset';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import {Messages} from 'primereact/messages';

import Api from '../utils/Api';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.Api = new Api();
    this.state = {username: 'admin', password: ''};
    this.handleLogin = this.handleLogin.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleKeyDown(event) {
    // enter key submits
    if (event.key==='Enter') {
      this.handleLogin(event)
    }
  }

  handleLogin(event) {
    this.Api.auth.login({
      username: this.state.username,
      password: this.state.password
    }).then((res) => {
      this.messages.clear();
      this.props.onLogin(res);
    },(error) => {
      console.log(error);
      this.messages.clear();
      this.messages.show({
        closable: false,
        sticky: true,
        severity: 'error',
        summary: '',
        detail: 'Username / password incorrecte'
      });
    });
  }

  render() {
    return (

      <div className="grid justify-center" style={{marginTop:50}}>
          <div className="col-6">
            <Fieldset legend="Login">

              <div className="grid">
                <div className="col-12">
                    <label>Username</label>
                </div>
                <div className="col-12">
                    <InputText
                      placeholder="user@foobar.com"
                      value={this.state.username}
                      onKeyDown={this.handleKeyDown}
                      onChange={(e) => this.setState({username: e.target.value})}
                    />
                </div>

                <div className="col-12">
                    <label>Password</label>
                </div>
                <div className="col-12">
                    <Password
                      feedback={false}
                      name='password'
                      value={this.state.password}
                      onKeyDown={this.handleKeyDown}
                      onChange={(e) => this.setState({password: e.target.value})}
                    />
                </div>

                <div className="col-12">
                    <Button label="Login" onClick={this.handleLogin}/>
                </div>

                <Messages ref={(el) => this.messages = el}></Messages>

              </div>
            </Fieldset>
          </div>
      </div>


    );
  }
}
export default Login;
